import { Link, Navigate, useParams } from 'react-router-dom';
import { getProjectBySlug } from '@/data/projects';

export default function ProjectPage() {
  const { slug } = useParams();
  const project = getProjectBySlug(slug);

  // 用户手动输入不存在的项目 slug 时，回到 Art 列表，避免详情页空白。
  if (!project) {
    return <Navigate to="/art" replace />;
  }

  // gallery 中的 images 只保存文件名，项目目录在这里统一拼接，减少数据重复。
  const projectDir = `/assets/art-projects/${project.slug}`;

  return (
    <main>
      <section className="section project-page">
        <div className="project-back-row">
          <Link to="/art" className="project-back-link">
            Back to Art
          </Link>
        </div>

        {/* 部分项目没有视频，使用条件渲染保留详情页结构的弹性。 */}
        {project.video ? (
          <div className="project-video-block">
            <video
              className="project-video"
              playsInline
              controls
              preload="none"
              poster={project.poster}
            >
              <source src={project.video} type="video/mp4" />
            </video>
          </div>
        ) : null}

        <div className="project-hero">
          <div className="project-hero-copy">
            <p className="section-title">Project</p>
            <h1 className="project-title">{project.title}</h1>
            <p className="project-meta">
              {project.year} - {project.location}
            </p>
            <p className="project-medium">{project.medium}</p>
          </div>
          <div className="project-hero-note">
            <p>{project.note}</p>
          </div>
        </div>

        {/* leadImage 是视频和正文之间的主视觉图；没有配置时自动隐藏。 */}
        {project.leadImage ? (
          <div className="project-image-block project-image-block--lead">
            <img
              loading="eager"
              decoding="async"
              fetchPriority="high"
              src={project.leadImage}
              alt={`${project.title} still`}
              className="project-image"
            />
          </div>
        ) : null}

        <section className="project-statement-block">
          <div className="project-statement-head">
            <p className="section-title">Statement</p>
          </div>
          <div className="project-statement essay-statement">
            {project.statement.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </section>

        {/* 不同项目的画廊比例差异很大，因此布局 class 由数据层指定。 */}
        <div className={`project-gallery ${project.galleryClass}`}>
          {project.images.map((image, index) => (
            <figure className={`project-figure ${project.figureClass}`} key={image}>
              <img
                loading={index === 0 ? 'eager' : 'lazy'}
                decoding="async"
                fetchPriority={index === 0 ? 'high' : 'auto'}
                src={`${projectDir}/${image}`}
                alt={`${project.title} image ${index + 1}`}
                className="project-image"
              />
            </figure>
          ))}
        </div>
      </section>
    </main>
  );
}
